import React from 'react';
import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';

import DuplicateError from '../presentational/DuplicateError';

const Container = styled('div')`
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 60px 48px;
  position: relative;
  width: 440px;

  .return-link {
    margin-top: 30px;
  }
`;

const DuplicateErrorContainer = () => {
  const location = useLocation();
  const email = new URLSearchParams(location.search).get('email');

  return (
    <Container>
      <DuplicateError email={email} />
    </Container>
  );
};

export default DuplicateErrorContainer;
